export default __webpack_public_path__ + "static/media/ic-chapter-test.7af45735.svg";